import { render } from "./addFunc.vue?vue&type=template&id=35bd61c2"
import script from "./addFunc.vue?vue&type=script&lang=js"
export * from "./addFunc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__